import { Button, Icon, Text } from '@nimbus-ds/components';
import { GenerativeStarsIcon } from '@nimbus-ds/icons';

interface ChatMessageActionProps {
  confirmed: boolean;
  onClick: () => void;
  label: string;
}

/**
 * Action button for confirming AI-generated action chains
 */
function ChatMessageAction({
  confirmed,
  onClick,
  label,
}: Readonly<ChatMessageActionProps>): JSX.Element {
  return (
    <Button
      appearance="ai-primary"
      onClick={onClick}
      disabled={confirmed}
      fullWidth
    >
      <Icon
        source={<GenerativeStarsIcon size="small" />}
        color={confirmed ? 'neutral-textDisabled' : 'neutral-surface'}
      />
      <Text color={confirmed ? 'neutral-textLow' : 'neutral-surface'}>
        {label}
      </Text>
    </Button>
  );
}

export default ChatMessageAction;
